/* eslint-disable react/jsx-props-no-spreading */
import { Image } from './Image.styles';
import type { ImageProps } from './Image.d';

const ImageBase = ({ alt, opacity = '100', ratio = '1x1', src, ...props }: ImageProps) => (
  <Image.Component
    alt={alt}
    data-opacity={opacity}
    data-ratio={ratio}
    loading="lazy"
    src={src}
    {...props}
  />
);
export default ImageBase;
